/** Drops null / undefined / `'null'` so they never hit the query string. Optional aliases rename query keys. */
export function compactQuery<T extends object>(
  query?: T | null,
  aliases?: Record<string, string> | null,
): T {
  const result: Record<string, unknown> = {};
  if (query) {
    Object.keys(query).forEach((key) => {
      const value = (query as Record<string, unknown>)[key];
      if (value !== null && value !== undefined && value !== 'null') {
        result[key] = value;
      }
    });
  }
  if (aliases) {
    Object.keys(aliases).forEach((from) => {
      if (result[from] !== undefined) {
        result[aliases[from]] = result[from];
        delete result[from];
      }
    });
  }
  return result as T;
}

/** Same as compactQuery, then drops pagination keys for export. */
export function compactExportQuery<T extends object>(
  query?: T | null,
  aliases?: Record<string, string> | null,
): T {
  const result = compactQuery(query, aliases) as Record<string, unknown>;
  delete result['pageSize'];
  delete result['pageNumber'];
  return result as T;
}
